import { useCart } from '../context/CartContext';
import './CartSidebar.css';

export default function CartSidebar() {
  const { cart, isOpen, closeCart, changeQty, removeFromCart, totalPrice, totalItems, orderWhatsApp } = useCart();

  return (
    <>
      <div className={`cart-overlay ${isOpen ? 'open' : ''}`} onClick={closeCart} />
      <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="cart-head">
          <div className="cart-head-left">
            <span className="cart-title">MY CART</span>
            <span className="cart-count">{totalItems}</span>
          </div>
          <button className="cart-x" onClick={closeCart}>✕</button>
        </div>

        <div className="cart-items">
          {cart.length === 0 ? (
            <div className="cart-empty">
              <div className="cart-empty-icon">🛒</div>
              <p>Your cart is empty</p>
              <p className="cart-empty-sub">Add some awesome gadgets!</p>
            </div>
          ) : (
            cart.map(item => (
              <div key={item.id} className="cart-item">
                <div className="cart-item-img">{item.emoji}</div>
                <div className="cart-item-info">
                  <div className="cart-item-brand">{item.brand}</div>
                  <div className="cart-item-name">{item.name}</div>
                  <div className="cart-item-row">
                    <div className="cart-item-price">${(item.price * item.qty).toLocaleString()}</div>
                    <div className="qty-ctrl">
                      <button className="qty-btn" onClick={() => changeQty(item.id, -1)}>−</button>
                      <span className="qty-num">{item.qty}</span>
                      <button className="qty-btn" onClick={() => changeQty(item.id, 1)}>+</button>
                    </div>
                  </div>
                  <button className="cart-remove" onClick={() => removeFromCart(item.id)}>✕ Remove</button>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <div className="cart-foot">
            <div className="cart-subtotal">
              <span className="cart-subtotal-label">Subtotal</span>
              <span className="cart-subtotal-price">${totalPrice.toLocaleString()}</span>
            </div>
            <button className="cart-checkout">Proceed to Checkout →</button>
            <button className="cart-wa-checkout" onClick={orderWhatsApp}>
              📱 Order via WhatsApp
            </button>
          </div>
        )}
      </div>
    </>
  );
}
